export default __webpack_public_path__ + "static/media/santeFilled.ae6626e3.svg";